module.exports = __webpack_public_path__ + "img/bnd_head_sku_2.prt.699a94a4.jpg";